import {MouseEventHandler} from "react";

interface NextButtonProps {
    onClick : MouseEventHandler
    showTitle? : boolean
}

export function NextButton(props : NextButtonProps) {
    return <button onClick={props.onClick} className="btn next">{ props.showTitle === true && "Dalej"}</button>;
}